import React, { useState } from 'react';

/**
 * The plans an employee holds, in a roster cell.
 *
 * A company can run several offers on one meal type, and querying a tab that
 * holds three of them puts three names in every row — enough to push the row to
 * two or three lines and cost the table its scannability. So two names show and
 * the rest collapse behind a +N the SPOC can open.
 *
 * Two is the cut because it is the point where a cell stops reading as a value
 * and starts reading as a list. The count is on the control itself, so a
 * collapsed cell still says how many are hidden without being opened.
 */
const VISIBLE = 2;

const MealPlanOfferChips = ({ names = [] }) => {
  const [expanded, setExpanded] = useState(false);

  if (!names.length) return '–';

  const hidden = names.length - VISIBLE;
  const shown = expanded || hidden <= 0 ? names : names.slice(0, VISIBLE);

  return (
    <span className="MealPlanUsers_OfferTags">
      {shown.map(name => (
        <span className="MealPlanUsers_OfferTag" key={name}>
          {name}
        </span>
      ))}

      {hidden > 0 ? (
        <button
          type="button"
          className="MealPlanUsers_OfferTag MealPlanUsers_OfferMore"
          aria-expanded={expanded}
          aria-label={
            expanded
              ? 'Show fewer meal plans'
              : `Show ${hidden} more meal plan${hidden === 1 ? '' : 's'}`
          }
          onClick={() => setExpanded(open => !open)}
        >
          {expanded ? 'Show less' : `+${hidden}`}
        </button>
      ) : null}
    </span>
  );
};

export default MealPlanOfferChips;
